module.exports = __webpack_public_path__ + "img/AT0000002577888.ff25a282.png";